import React, { createContext, useState, useReducer, useEffect } from 'react';
import {
  campanha,
  CampanhaContextProps,
  CampanhaTableContextProps,
  CampanhaValues,
  filters,
} from 'models/campanhas';
import Loader from 'components/Loader';
import {
  campanhaReducer,
  initialErrorState,
  initialState,
} from 'utils/campanha-utils';
import { addDays, format, parse } from 'date-fns';

const CampanhaTableContext = createContext({} as CampanhaTableContextProps);

export const UseCampanhaTableContext = () =>
  React.useContext(CampanhaTableContext);

const CampanhaTableProvider: React.FC = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<campanha>();
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <CampanhaTableContext.Provider
      value={{
        anchorEl,
        open,
        selected,
        setAnchorEl,
        setOpen,
        setSelected,
      }}
    >
      {children}
    </CampanhaTableContext.Provider>
  );
};

const CampanhaContext = createContext({} as CampanhaContextProps);

export const UseCampanhaContext = () => React.useContext(CampanhaContext);

export const CampanhaProvider: React.FC = ({ children }) => {
  const [currentFilters, setCurrentFilters] = useState<filters>();
  const [refreshList, setRefreshList] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [filterOpened, setFilterOpened] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [searchName, setSearchName] = useState<string>('');
  const [defaultFileModalOpen, setDefaultFileModalOpen] = useState(false);

  const [formCampanhaValues, dispatch] = useReducer(
    campanhaReducer,
    initialState,
  );
  const [formCampanhaErrors, setFormCampanhaErrors] = useState(
    initialErrorState,
  );

  const handleInputChangeContext = (inputName: string, value: any) => {
    dispatch({
      type: 'INPUT_CHANGE',
      input: { name: inputName, value },
    });
  };

  const getFinalDate = () => {
    if (!formCampanhaValues) return;

    const formatedInitialDate = parse(
      String(formCampanhaValues[CampanhaValues.DATA_DE_INICIO]),
      "dd'-'MM'-'yyyy",
      new Date(),
    );
    const finalDate = addDays(
      formatedInitialDate,
      Number(formCampanhaValues[CampanhaValues.DURACAO]),
    );
    const formatedFinalDate = format(finalDate, "dd'-'MM'-'yyyy");

    handleInputChangeContext(CampanhaValues.DATA_DE_FIM, formatedFinalDate);
  };

  useEffect(() => {
    if (
      formCampanhaValues[CampanhaValues.DATA_DE_INICIO] &&
      formCampanhaValues[CampanhaValues.DURACAO]
    ) {
      getFinalDate();
    } else {
      handleInputChangeContext(CampanhaValues.DATA_DE_FIM, '');
    }
  }, [
    formCampanhaValues[CampanhaValues.DATA_DE_INICIO],
    formCampanhaValues[CampanhaValues.DURACAO],
  ]);

  useEffect(() => {
    if (!window.location.href.includes('/criar-campanha')) {
      dispatch({
        type: 'RESET_VALUES',
      });
      setFormCampanhaErrors(initialErrorState);
    }
  }, [window.location.href]);

  return (
    <>
      {isLoading && <Loader />}
      <CampanhaContext.Provider
        value={{
          appliedFilters,
          currentFilters,
          currentPage,
          defaultFileModalOpen,
          filterOpened,
          formCampanhaErrors,
          formCampanhaValues,
          isLoading,
          page,
          refreshList,
          searchName,
          dispatch,
          setAppliedFilters,
          setCurrentFilters,
          setCurrentPage,
          setDefaultFileModalOpen,
          setFilterOpened,
          setFormCampanhaErrors,
          setIsLoading,
          setPage,
          setRefreshList,
          setSearchName,
        }}
      >
        <CampanhaTableProvider>{children}</CampanhaTableProvider>
      </CampanhaContext.Provider>
    </>
  );
};
